import { UserTier } from '@/entities/permissions/types';
import type { UserSubscription } from '@/types/auth';

export const resolveUserTier = (
  subscription: UserSubscription | null,
  isExpired: boolean
): UserTier => {
  if (!subscription) return UserTier.Public;
  if (isExpired) return UserTier.Expired;
  if (subscription.trial) return UserTier.Trial;
  if (subscription.plan !== 'Premium') return UserTier.Basic;
  return UserTier.Premium;
};
